module.exports = __webpack_public_path__ + "img/icon-mobile-device.1ca476dd.svg";